import { Node, mergeAttributes } from "@tiptap/core";
import {
    PADDING_X_MM,
    PADDING_Y_MM,
    PAGE_HEADER_HEIGHT_MM,
    PAGE_HEIGHT_MM,
    PAGE_WIDTH_MM,
} from "../constants";

export const PageNode = Node.create({
    name: "page",
    group: "block",
    content: "block*",
    defining: true,

    parseHTML() {
        return [
            {
                tag: "div[data-page]",
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "div",
            mergeAttributes(HTMLAttributes, {
                "data-page": true,
                class: "page",
            }),
            0,
        ];
    },

    addNodeView() {
        return () => {
            const dom = document.createElement("div");
            dom.setAttribute("data-page", "true");
            dom.classList.add("page");
            dom.style.height = `${PAGE_HEIGHT_MM}mm`;
            dom.style.width = `${PAGE_WIDTH_MM}mm`;
            dom.style.padding = `${PADDING_Y_MM}mm ${PADDING_X_MM}mm`;

            dom.style.overflow = "hidden";
            dom.style.position = "relative";

            const pageHeader = document.createElement("div");
            pageHeader.setAttribute("data-type", "page-header");
            pageHeader.classList.add("page-header");
            pageHeader.style.height = `${PAGE_HEADER_HEIGHT_MM}mm`;
            pageHeader.contentEditable = "false";
            dom.appendChild(pageHeader);

            const headerImage = document.createElement("img");
            headerImage.setAttribute("data-type", "header-image");
            headerImage.classList.add("header-image");
            headerImage.src = this.options.headerImageSrc;
            headerImage.contentEditable = "false";
            headerImage.draggable = false;
            headerImage.style.marginLeft = `-20mm`;
            headerImage.style.height = "100%";
            headerImage.style.width = "auto";
            headerImage.style.objectFit = "contain";
            headerImage.style.display = "block";
            pageHeader.appendChild(headerImage);

            const contentDOM = document.createElement("div");
            dom.appendChild(contentDOM);

            return {
                dom,
                contentDOM,
            };
        };
    },
});
